/**
 * Displays a section of the sidebar stats bar with a stat and the teams percentages.
 */
import React from 'react';

const StatsBarSection = ({ statName, stat1, stat2, pct1, pct2, col1, col2 }) => {

    return (
        <div className="flex flex-col items-center mt-2">
            <div className="flex flex-row justify-between items-center w-full">
                <p className="w-20 text-left">{stat1}</p>
                <p className="text-center font-light">{statName}</p>
                <p className="w-20 text-right">{stat2}</p>
            </div>
            <div className="flex w-full flex-row justify-between items-center mt-1">
                {isNaN(pct1) && isNaN(pct2) &&
                    <div className="flex flex-col justify-center items-center h-3"
                         style={{width: `100%`, opacity: `50%`, backgroundColor: `#888888`}}></div>
                }
                <div className="flex flex-col justify-center items-center h-3"
                     style={{width: `${pct1}%`, backgroundColor: `${col1}`}}></div>
                <div className="flex flex-col justify-center items-center h-3" style={{ width: `${pct2}%`, backgroundColor: `${col2}` }}> </div>
            </div>
        </div>
    );
};

export default StatsBarSection;